import P1Medium from 'components/typography/P1Medium';
import P2Regular from 'components/typography/P2Regular';
import P2Medium from 'components/typography/P2Medium';
import {
  ConfirmationFormData,
  useGatherConfirmation,
} from 'components/tables/data/revision/actions/confirm/GatherConfirmationProvider';
import { useCallback } from 'react';
import { Box, Center, Group, Stack } from '@mantine/core';
import { IconEdit, IconPlus } from '@tabler/icons-react';
import { noop } from 'lodash';
import P3Medium from 'components/typography/P3Medium';
import Button from 'components/Button';

interface ConfirmationRowProps {
  label: string;
  index: number;
  value?: ConfirmationFormData;
  error?: string;
  autosuggestDataType?: string;
  onChange?: (value: ConfirmationFormData) => void;
}

/**
 * Row for displaying a confirmation.
 */
export default function ConfirmationRow({
  label,
  index,
  value,
  error,
  autosuggestDataType,
  onChange = noop,
}: ConfirmationRowProps) {
  const { gatherConfirmation } = useGatherConfirmation();

  const addConfirmation = useCallback(() => {
    gatherConfirmation({
      title: `Pridať potvrdenie - ${label}`,
      initialValues: value,
      autosuggestDataType,
      onConfirm: onChange,
    });
  }, [gatherConfirmation, label, value, autosuggestDataType, onChange]);

  return (
    <Group spacing={8} align="start" noWrap>
      <P2Medium color="gray.7">{index + 1}.</P2Medium>
      <Stack spacing={0}>
        <P1Medium color="gray.8">{label}</P1Medium>
        <P2Regular color="gray.7">{value?.name ? `${value.name} - digitálny podpis` : ''}</P2Regular>
        <Box mt={8}>
          <Button
            variant="secondary"
            size="sm"
            leftIcon={value ? <IconEdit /> : <IconPlus />}
            onClick={addConfirmation}
          >
            {value ? 'Upraviť potvrdenie' : 'Pridať potvrdenie'}
          </Button>
        </Box>
        {!!error && <P2Regular color="red">{error}</P2Regular>}
      </Stack>
      {value?.signature ? (
        <img src={value.signature} width={180} height="auto" alt="Digitálny podpis" className="ml-auto" />
      ) : (
        <Center w={180} h={68} className="ml-auto rounded-md border border-dashed border-[var(--mantine-color-gray-1)]">
          <P3Medium c="gray.4">DIGITÁLNY PODPIS</P3Medium>
        </Center>
      )}
    </Group>
  );
}
